import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { AddPersonToGroupUseCaseInterface } from 'domain/usecases';

export class RemoteAddPersonToGroup
  implements AddPersonToGroupUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<AddPersonToGroupUseCaseInterface.Result>,
  ) {}

  async execute(
    params: AddPersonToGroupUseCaseInterface.Params,
  ): Promise<AddPersonToGroupUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'post',
      url: `${this.url}`,
      body: params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
